var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10 .102 19.25 6.2v12.55H.75V6.2zM2.25 7.008V17.25h15.5V7.008L10 1.898z",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m14.469 10.585-3.497 2.798-2-1.8-2.503 2.002-.938-1.17L9.03 9.615l2 1.8 2.502-2.002z",
    clipRule: "evenodd"
  })));
};
export { SvgHome as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC41IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEwIDAuMTAxNTYyTDE5LjI1IDYuMjAwNDZWMTguNzQ5OUgwLjc1VjYuMjAwNDZMMTAgMC4xMDE1NjJaTTIuMjUgNy4wMDgxNlYxNy4yNDk5SDE3Ljc1VjcuMDA4MTZMMTAgMS44OTgyN0wyLjI1IDcuMDA4MTZaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE0LjQ2ODUgMTAuNTg1NEwxMC45NzE1IDEzLjM4M0w4Ljk3MTQ1IDExLjU4M0w2LjQ2ODU0IDEzLjU4NTRMNS41MzE0OSAxMi40MTQxTDkuMDI4NTggOS42MTY0TDExLjAyODYgMTEuNDE2NEwxMy41MzE1IDkuNDE0MDZMMTQuNDY4NSAxMC41ODU0WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";